import { FieldForm } from "components/RFQ/Input/Input";

export const TemplateDetail = () => {
	return (
		<div>
			<h2 className="py-8 font-heading text-[36px] text-royal-blue">
				Template Name{" "}
			</h2>
			<div className="grid grid-cols-2 gap-8">
				<FieldForm
					label="Template name"
					placeholder="Eg. Woolworths Inglewood RFx"
					name="template_name"
					required
					maxLength={255}
				/>
			</div>
		</div>
	);
};
